import React, { useEffect, useMemo, useState } from "react";
import { Alert, Button, Modal } from "react-bootstrap";
import AdyenCheckout from '@adyen/adyen-web';
import { ApplePayButtonType } from "@adyen/adyen-web/dist/types/components/ApplePay/types";
import UIElement from "@adyen/adyen-web/dist/types/components/UIElement";
import { getStrings } from "../../Shared/Reservation/StringResources";
import { getSettings } from "../Settings";
import { IPaymentSessionData } from "../Models";
import { getDefaultHeaders } from "../Settings";

const strings = getStrings().component.payment;

export interface IAdyenDialogProps {
	paymentId: string;
	sessionData: string;
	environment: string;
	clientKey: string;
	amount: number;
	bookingNumber: string;
	onPaymentAborted: () => void
};

export const AdyenDialog = (props: IAdyenDialogProps) => {
	const environment = props.environment;

	// const [showModal, setShowModal] = useState(false);
	const [allowCancel, setAllowCancel] = useState(true);
	const [paymentComplete, setPaymentComplete] = useState(false);
	const [error, setError] = useState("");

	const configuration = useMemo(() => ({
		environment,
		clientKey: props.clientKey,
		session: {
			id: props.paymentId,
			sessionData: props.sessionData
		},
		onPaymentCompleted: (result: { resultCode: string }, component: UIElement) => {

			console.debug("Adyen.onPaymentCompleted", result, component);
			if (result.resultCode === "Authorised")
			{
				setAllowCancel(false);
				setPaymentComplete(true);
				setTimeout(checkPaymentStatus, 1000); //Så kanske notifikationen redan kommit
			}
		},
		onError: (error: { name: string, message?: string, stack?: string }, component: UIElement) => {
			console.error("Adyen.onError", error.name, error.message, error.stack, component);
			setError("Ett fel uppstod när Adyen skulle kontaktas, var vänlig försök igen.")
		},
		paymentMethodsConfiguration: {
			applepay: {
				buttonType: "book" as ApplePayButtonType
				//buttonColor: "white-with-line"
			},
			card: {
				enableStoreDetails: false
			},
			paypal: {
				environment,
				countryCode: "SE",
				amount: {
					currency: "SEK",
					value: props.amount
				}
			}
		}
	}), [props.paymentId]);

	useEffect(() => {
		if (!configuration)
			return;

		const setupAdyen = async () => {
			const c = await AdyenCheckout(configuration);
			const el = c.create('dropin');
			el.mount('#adyen-payment-container');
		};

		setupAdyen()
			.catch(console.error);

	}, [configuration]);

	const cancel = () => {
		console.debug("cancel payment");
		props.onPaymentAborted();

		//För att hantera-bokning ska kunna veta att betalningen avbröts
		// window.dispatchEvent(new CustomEvent("PaymentCancelled", { detail: {
		// 	provider: "adyen",
		// 	orderId: props.salesOrderId,
		// 	paymentId: props.paymentId,
		// 	amount: props.amount
		// }}));
	};

	const checkPaymentStatus = async () => {

		//TODO: Vi måste ha något sätt att avbryta detta om bekräftelsen inte kommit inom en viss tid

		const settings = getSettings();
		const response = await fetch(`${settings.apiUrl}/payment/session/${props.paymentId}` , {
			method: "GET",
			headers: getDefaultHeaders()
		});
		if (response.ok)
		{
			const data = await response.json() as IPaymentSessionData;
			console.debug("Payment session data", data.result, data.pspReference);
			if (data.pspReference)
				window.location.href = `${settings.receiptUrl}?bookingNumber=${props.bookingNumber}&paymentReference=${data.pspReference}`;
			else
				setTimeout(checkPaymentStatus, 1000);
		}
		else
		{
			setError(`Det gick inte att hämta bokningen: ${response.status} ${response.statusText}`);
		}
	};

	return <><Modal show centered backdrop="static" onClose={cancel} onHide={cancel} animation={false}>
		{/* <Modal.Header><Modal.Title>Fejkbetalning</Modal.Title></Modal.Header> */}
		<Modal.Body>
			<div id="adyen-payment-container"></div>

			<Alert variant="danger" className="mt-3" show={error ? true : false}><strong>Fel</strong> {error}</Alert>
			<Alert variant="success" className="mt-3" show={paymentComplete}>
				{strings.paymentComplete}
			</Alert>
		</Modal.Body>
		<Modal.Footer>
			<Button variant="outline-secondary" disabled={!allowCancel} onClick={cancel}>{strings.cancel}</Button>
		</Modal.Footer>

	</Modal>

	</>;
};